import React from "react";
import styles from "./Style.module.css";
// import DashboardSnackbar from "../../../components/Snackbar.component";
import classNames from "classnames";
import logoImage from "../../../src/assets/CRMAssets/login_logo@2x.png";
import { IconButton, ButtonBase, Typography, Button, CircularProgress } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomTextField from "../../../src/components/FormFields/TextField/TextField.component";
import { useTheme } from "@mui/styles";
import useLoginDietitianHook from "./LoginDietitian.hook";
import { ArrowPrimaryButton } from "../../components/Buttons/PrimaryButton";
import PhoneNo from "../../views/LoginDietitian/Component/Phone";
import SnackbarUtils from "../../libs/SnackbarUtils";
import DashboardSnackbar from "../../components/Snackbar.component";
import { useSelector } from "react-redux";

function LoginDietitian() {
    const theme = useTheme();
    const { domainTheme } = useSelector((state) => state.app_setting);
    const {
        handleSubmit,
        onBlurHandler,
        changeTextData,
        form,
        errorData,
        isSubmitting
    } = useLoginDietitianHook();

    const bgUrl = domainTheme?.background_image;
    const logoUrl = domainTheme?.display_logo || logoImage;

    return (
        <div className={"login"} id="loginview" style={{ backgroundImage: bgUrl ? `url(${bgUrl})` : undefined, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className={styles.overlay}></div>
            <div className={styles.mainLoginView}></div>
            <div className={styles.container}>
                <div className={styles.loginFlex2}>
                    <div className={styles.logoImageData}>
                        <img src={logoUrl} alt="text_data" style={{ width: "250px" }} />
                    </div>
                    <div className={styles.signContainer}>
                        <div className={styles.loginHeaderText}>
                            <Typography variant="h3">Dietitian Login</Typography>

                            <Typography
                                variant={"body1"}
                                sx={{ color: theme?.palette?.text?.secondary }}
                            >
                                Please enter your phone number to login
                            </Typography>
                        </div>

                        <div className={styles.formContainer}>
                            <div className={styles.formFlexGrouup}>
                                <div className={"formGroup"}>
                                    <PhoneNo
                                        errorData={errorData}
                                        form={form}
                                        changeTextData={changeTextData}
                                    // isSubmitting={isSubmitting}
                                    // isPhoneDisabled={isPhoneDisabled}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className={styles.loginAction}>
                            <Button
                                variant={"h6"}
                                onClick={() => handleSubmit()}
                            >
                                {isSubmitting ? (
                                    <CircularProgress size={24} color={"primary"} />
                                ) : (
                                    "LOGIN"
                                )}
                            </Button>


                        </div>

                    </div>
                </div>

            </div>
            <DashboardSnackbar />
        </div>
    );
}

export default LoginDietitian;
